<template>
  <div class="profile_edit">
    <v-form ref="formProfileEdit">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            Datos básicos
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">
            Datos complementarios
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3"> Documentos </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-12" elevation="0">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Primer Nombre"
                    type="text"
                    v-model="model.first_name"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Segundo Nombre"
                    type="text"
                    v-model="model.second_name"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Primer Apellido"
                    type="text"
                    v-model="model.surname"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Segundo Apellido"
                    type="text"
                    v-model="model.second_surname"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Cédula"
                    type="text"
                    v-model="model.colombian_id"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Teléfono"
                    type="text"
                    v-model="model.phone"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Dirección"
                    type="text"
                    v-model="model.address"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Correo"
                    type="text"
                    v-model="model.email"
                    :rules="[
                      this.$store.state.rules.required,
                      this.$store.state.rules.email,
                    ]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Crea tu contraseña"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    v-model="model.password"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Confirmar contraseña"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    v-model="model.password_confirmation"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <v-btn color="primary" @click="step = 2"> Continuar </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-12" elevation="0">
              <v-row>
                <v-col class="12" md="4">
                  <v-select
                    :items="this.$store.state.status.bloodTypes"
                    label="Tipo de sangre"
                    type="text"
                    v-model="model.blood_type"
                    :rules="[this.$store.state.rules.required]"
                  ></v-select>
                </v-col>

                <v-col class="12" md="4">
                  <v-menu
                    v-model="menuDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.birthday"
                        label="Fecha de nacimiento"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.birthday"
                      @input="menuDate = false"
                      color="secondary"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="12" md="4">
                  <v-text-field
                    label="Ciudad de expedición"
                    type="text"
                    v-model="model.expedition_city"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col class="12" md="4">
                  <v-text-field
                    label="Eps"
                    type="text"
                    v-model="model.eps"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col class="12" md="4">
                  <v-text-field
                    label="Pensión"
                    type="text"
                    v-model="model.pension"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col class="12" md="4">
                  <v-text-field
                    label="Operador de pila (seguridad social)"
                    type="text"
                    v-model="model.stack_operator"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col class="12" md="4">
                  <v-text-field
                    label="Correo segundario"
                    type="text"
                    v-model="model.second_email"
                    :rules="[this.$store.state.rules.email]"
                  ></v-text-field>
                </v-col>

                <v-col class="12" md="4">
                  <v-text-field
                    label="Teléfono fijo"
                    type="text"
                    v-model="model.landline"
                    :rules="[this.$store.state.rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <v-btn color="primary" @click="step = 3"> Continuar </v-btn>

            <v-btn text @click="step = 1"> Atrás </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="mb-12" elevation="0">
              <v-expansion-panels primary>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="primary"
                    class="white--text font-weight-bold"
                  >
                    Aprende a subir tus documentos
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="text-left py-4">
                    El peso máximo de cada archivo debe ser de 10 MB, si tus
                    archivos pesan mas que esto debes comprimir el peso de cada
                    archivo hasta que pesen menos de los 10 MB mencionados
                    anteriormente. Si los archivos que tiene son distintos a PDF se 
                    recomienda convertir estos a PDF y posteriormente comprimir el peso del 
                    pdf, abajo podrá encontrar distintas páginas para
                    comprimir sus archivos.

                    <br />
                    <br />

                    <v-sheet
                      color="primary"
                      elevation="2"
                      class="white--text font-weight-medium pa-2 mb-7"
                    >
                      NOTA: LO IDEAL ES QUE CADA ARCHIVO PESE ENTRE 1 MB A 2 MB,
                      ESTO AYUDA A QUE SE PUEDA SUBIR TODO CORRECTAMENTE. SI SUS
                      ARCHIVOS NO SUBEN CORRECTAMENTE LE RECOMENDAMOS SUBIR LOS
                      ARCHIVOS DE 3 EN 3, PARA QUE PUEDAN CARGAR CORRECTAMENTE.
                    </v-sheet>

                    <v-row align="center" justify="space-around">
                      <v-btn
                        color="primary"
                        href="https://tools.pdf24.org/es/comprimir-pdf#s=1647293335228"
                        target="_blanck"
                      >
                        Comprimir PDF
                      </v-btn>

                      <v-btn
                        color="primary"
                        href="https://www.ilovepdf.com/es/jpg_a_pdf"
                        target="_blanck"
                      >
                        Imagen a PDF
                      </v-btn>

                      <v-btn
                        color="primary"
                        href="https://www.ilovepdf.com/es/word_a_pdf"
                        target="_blanck"
                      >
                        Word a PDF
                      </v-btn>

                      <v-btn
                        color="primary"
                        href="https://www.ilovepdf.com/es/excel_a_pdf"
                        target="_blanck"
                      >
                        Excel a PDF
                      </v-btn>

                      <v-btn
                        color="primary"
                        href="https://www.ilovepdf.com/es/powerpoint_a_pdf"
                        target="_blanck"
                      >
                        POWERPOINT a PDF
                      </v-btn>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Foto"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.photo_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Propuesta"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.proposal_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Rut actualizado (fecha superior a Septiembre 2020)"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.rut_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Hoja de vida con foto"
                :rules="[this.$store.state.rules.required]"
                v-model="model.cv_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Soportes de hoja de vida"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.cv_supports_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Cedula Legible"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.colombian_id_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Antecedentes Fiscales expedido por la Contraloría General de la República"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_criminal_records_by_Comptroller_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Antecedentes Fiscales Expedido por la Procuraduría General de la República"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="
                  model.certificate_criminal_records_by_attorney_office_file
                "
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Consulta de antecedentes Policía Nacional"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_criminal_records_by_police_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Consulta de Medidas correctivas expedido por la Policía Nacional"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_corrective_measures_by_police_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificación Bancaria Actualizada"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_bank_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Examen Médico Ocupacional vigente"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.medical_exams_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Afiliación a EPS vigente"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_eps_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Afiliación a AFP (pensión)"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_afp_file"
              ></v-file-input>
              
               <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Redam"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_redam_file"
              ></v-file-input>
              
               <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Delitos sexuales"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                v-model="model.certificate_sexual_file"
              ></v-file-input>
            </v-card>

            <v-btn color="primary" @click="register()"> Guardar </v-btn>

            <v-btn text @click="step = 2"> Atrás </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>
  </div>
</template>


<script>
import { SET_USER } from "@/store/user";
import { SET_ALERT } from "@/store/alert";
export default {
  name: "register",
  data() {
    return {
      showPassword: false,
      menuDate: false,
      step: 1,
      user: null,
      model: {
        //Data user
        email: "",
        password: "",
        first_name: "",
        second_name: "",
        surname: "",
        second_surname: "",
        colombian_id: "",
        phone: "",
        address: "",
        //Data employee
        blood_type: "",
        birthday: "",
        eps: "",
        pension: "",
        stack_operator: "",
        second_email: "",
        landline: "",
        expedition_city: "",
        //Files
        rut_file: [],
        cv_file: [],
        cv_supports_file: [],
        colombian_id_file: [],
        certificate_criminal_records_by_Comptroller_file: [],
        certificate_criminal_records_by_attorney_office_file: [],
        certificate_criminal_records_by_police_file: [],
        certificate_corrective_measures_by_police_file: [],
        certificate_bank_file: [],
        medical_exams_file: [],
        certificate_eps_file: [],
        certificate_afp_file: [],
        certificate_redam_file: [],
        certificate_sexual_file: [],
        proposal_file: [],
        photo_file: [],
      },
    };
  },
  created() {
    this.$store.dispatch("getUser");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_USER) {
        this.user = state.user.user;
        this.serData();
      }
    });
  },
  methods: {
    serData() {
      //Data user
      this.model.email = this.user.email;
      this.model.first_name = this.user.first_name;
      this.model.second_name = this.user.second_name;
      this.model.surname = this.user.surname;
      this.model.second_surname = this.user.second_surname;
      this.model.colombian_id = this.user.colombian_id;
      this.model.phone = this.user.phone;
      this.model.address = this.user.address;
      //Data employee
      this.model.blood_type = this.user.employee.blood_type;
      this.model.birthday = this.user.employee.birthday;
      this.model.eps = this.user.employee.eps;
      this.model.pension = this.user.employee.pension;
      this.model.stack_operator = this.user.employee.stack_operator;
      this.model.second_email = this.user.employee.second_email;
      this.model.landline = this.user.employee.landline;
      this.model.expedition_city = this.user.employee.expedition_city;
    },
    register() {
      if (this.$refs.formProfileEdit.validate()) {
        this.$store.dispatch("editEmployee", {
          form: this.createFormData(),
          id: this.user.employee.id,
        });
      } else {
        this.step = 1;
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "info",
        });
      }
    },
    createFormData() {
      this.model._method = "put";
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (value != "" || value.length > 0 || key == "second_name") {
          formData.append(key, value);
        }
      });
      return formData;
    },
  },
};
</script>

<style>
.register {
  height: 100%;
}

.register__btn_already_user {
  text-transform: none;
  letter-spacing: normal;
  font-size: 0.85rem;
  margin: 1.5rem 0;
}

.register__btn_already_user :hover {
  background: none;
}

.v-list-item__title {
  text-align: left !important;
}
</style>
